import { render, staticRenderFns } from "./SlideDownUp2.vue?vue&type=template&id=1ec7961e&"
import script from "./SlideDownUp2.vue?vue&type=script&lang=js&"
export * from "./SlideDownUp2.vue?vue&type=script&lang=js&"
import style0 from "./SlideDownUp2.vue?vue&type=style&index=0&id=1ec7961e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports